import { tokenAtom } from "lib/globalState";
import { useRecoilValue } from "recoil";
import AltroUtenteModal from "./AltroUtenteModal";
import Timer from "./TimerModal";

import Disconnected from './Disconnected';

const Listeners = () => {
  const tokenActive = useRecoilValue(tokenAtom)

  return (
    <>
      {
        tokenActive &&
        <>
          <Disconnected />
          <Timer />
          <AltroUtenteModal />
        </>
      }
    </>

  )
}

export default Listeners;